module.exports = __webpack_public_path__ + "static/img/distribution_system2.25d653cf.jpg";